/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLocationRequestLegalInfo
 */
export interface CreateLocationRequestLegalInfo {
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationRequestLegalInfo
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLocationRequestLegalInfo
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    provinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    neighborhood?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    taxId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    legalEntityId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLocationRequestLegalInfo
     */
    entityType?: CreateLocationRequestLegalInfoEntityTypeEnum;
}


/**
 * @export
 */
export const CreateLocationRequestLegalInfoEntityTypeEnum = {
    Pf: 'PF',
    Sl: 'SL',
    Sa: 'SA',
    Coop: 'COOP',
    Sc: 'SC',
    Other: 'OTHER'
} as const;
export type CreateLocationRequestLegalInfoEntityTypeEnum = typeof CreateLocationRequestLegalInfoEntityTypeEnum[keyof typeof CreateLocationRequestLegalInfoEntityTypeEnum];


/**
 * Check if a given object implements the CreateLocationRequestLegalInfo interface.
 */
export function instanceOfCreateLocationRequestLegalInfo(value: object): value is CreateLocationRequestLegalInfo {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('taxId' in value) || value['taxId'] === undefined) return false;
    if (!('legalEntityId' in value) || value['legalEntityId'] === undefined) return false;
    return true;
}

export function CreateLocationRequestLegalInfoFromJSON(json: any): CreateLocationRequestLegalInfo {
    return CreateLocationRequestLegalInfoFromJSONTyped(json, false);
}

export function CreateLocationRequestLegalInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLocationRequestLegalInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'],
        'countryCode': json['countryCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'city': json['city'] == null ? undefined : json['city'],
        'province': json['province'] == null ? undefined : json['province'],
        'country': json['country'] == null ? undefined : json['country'],
        'email': json['email'],
        'taxId': json['taxId'],
        'legalEntityId': json['legalEntityId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
    };
}

export function CreateLocationRequestLegalInfoToJSON(json: any): CreateLocationRequestLegalInfo {
    return CreateLocationRequestLegalInfoToJSONTyped(json, false);
}

export function CreateLocationRequestLegalInfoToJSONTyped(value?: CreateLocationRequestLegalInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'street': value['street'],
        'number': value['number'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'countryCode': value['countryCode'],
        'provinceCode': value['provinceCode'],
        'neighborhood': value['neighborhood'],
        'city': value['city'],
        'province': value['province'],
        'country': value['country'],
        'email': value['email'],
        'taxId': value['taxId'],
        'legalEntityId': value['legalEntityId'],
        'entityType': value['entityType'],
    };
}

